import payImg from "../media/undraw_pay-with-credit-card_77g6 (1).svg"
import noPay from "../media/undraw_notify_drs8.svg"
import { Jelly } from "ldrs/react";
import paid from "../media/undraw_happy_fsrv.svg"
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

function ConfirmPay() {
  const [isLoad, setLoading] = useState(false);
  const [verificationStatus, setVerificationStatus] = useState("pending"); // pending, success, failed
  const [tokensReceived, setTokensReceived] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();

  // ✅ Extract reference from URL on page load
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const reference = queryParams.get("reference");
    const trxref = queryParams.get("trxref");
    

    
    if (reference) {
      // Automatically verify payment when page loads
      verifyPayment(reference);
    } else {
      Swal.fire({
        title: "No Reference Found",
        text: "No payment reference found in URL.",
        icon: "warning",
        confirmButtonColor: "#6a5acd",
      }).then(() => {
        navigate("/dashboard");
      });
    }
  }, [location]);
const verifyPayment = async (reference) => {
  setLoading(true);
  try {
    const data = new FormData();
    data.append("reference", reference);
  
    const response = await fetch("https://solaraback-g1bm.onrender.com/verify-payment", {
      method: 'POST',
      body: data
    });
    
    const result = await response.json();
    
    if (result.status === "success") {
      setVerificationStatus("success");
      setTokensReceived(result.tokens);
      
      // ✅ User must manually click the button to navigate
      Swal.fire({
        title: "Payment Verified! 🎉",
        html: `
          <div style="text-align: center;">
            <p style="font-size: 18px; margin-bottom: 10px;">Your payment was successful!</p>
            <p style="font-size: 32px; font-weight: bold; color: #6a5acd; margin: 10px 0;">
              +${result.tokens} Solara Tokens
            </p>
            <p style="font-size: 14px; color: #666;">Have been added to your account</p>
          </div>
        `,
        icon: "success",
        confirmButtonColor: "#6a5acd",
        confirmButtonText: "Go to Dashboard",
      }).then((result) => {
        // ✅ Only navigate if user clicks the button
        if (result.isConfirmed) {
          setLoading(false);
          navigate("/dashboard");
        } else {
          setLoading(false);
        }
      });
      
    } else if (result.status === "pending") {
      Swal.fire({
        title: "Payment Pending",
        text: "Your payment is still being processed. Please check back in a few minutes.",
        icon: "info",
        confirmButtonColor: "#6a5acd",
        confirmButtonText: "OK",
      }).then(() => {
        setLoading(false);
        // ✅ Stay on the page, don't auto-redirect
      });
      
    } else {
      setVerificationStatus("failed");
      Swal.fire({
        title: "Verification Failed",
        text: result.message || "Could not verify your payment. Please contact support.",
        icon: "error",
        confirmButtonColor: "#6a5acd",
        confirmButtonText: "OK",
      }).then(() => {
        setLoading(false);
        // ✅ Stay on the page
      });
    }
    
  } catch (error) {
    console.error("Verification error:", error);
    setVerificationStatus("failed");
    
    Swal.fire({
      title: "Verification Error",
      text: "Something went wrong. Please contact support.",
      icon: "error",
      confirmButtonColor: "#6a5acd",
      confirmButtonText: "OK",
    }).then(() => {
      setLoading(false);
      setVerificationStatus("pending");
    });
  }
};
  // Manual confirm button handler (if needed)
  const confirmPay = () => {
    const queryParams = new URLSearchParams(location.search);
    const reference = queryParams.get("reference");
    
    if (reference) {
      verifyPayment(reference);
    } else {
      Swal.fire({
        title: "No Reference Found",
        text: "No payment reference found.",
        icon: "warning",
        confirmButtonColor: "#6a5acd",
      });
    }
  };

  // Show different UI based on status
  const getDisplayImage = () => {
    if (verificationStatus === "success") return paid;
    if (verificationStatus === "failed") return noPay;
    return payImg;
  };

  const getDisplayMessage = () => {
    if (verificationStatus === "success") {
      return `+${tokensReceived} Tokens Added`;
    }
    if (verificationStatus === "failed") {
      return "Payment Verification Failed";
    }
    return "Confirm Payment";
  };

  return (
    <div className="confirmPayWrap">
      <div className="confirmPayBox">
        <img src={getDisplayImage()} alt="" />
        <span>{getDisplayMessage()}</span>
        
        {verificationStatus === "pending" && (
          <p>If you've already paid, click confirm payment to verify</p>
        )}
        
        {verificationStatus === "success" && (
          <p>Your tokens have been added to your account!</p>
        )}
        
        {verificationStatus === "failed" && (
          <p>Please contact support if you were charged</p>
        )}
        
   <div className="confirmPayBoxBtn">
  {isLoad ? (
    <Jelly size="45" speed="1" color="#6a5acd" />
  ) : (
    verificationStatus === "pending" && (
      <button onClick={confirmPay}>Confirm Payment</button>
    )
  )}
  
  {!isLoad && verificationStatus === "success" && (
    <button onClick={() => navigate("/dashboard")}>
      Go to Dashboard
    </button>
  )}
</div>
      </div>
    </div>
  );
}

export default ConfirmPay;